import { render, staticRenderFns } from "./ModalAssign.vue?vue&type=template&id=216d38cd&scoped=true"
import script from "./ModalAssign.vue?vue&type=script&lang=js"
export * from "./ModalAssign.vue?vue&type=script&lang=js"
import style0 from "./ModalAssign.vue?vue&type=style&index=0&id=216d38cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d38cd",
  null
  
)

export default component.exports